/* ================================================
   Injection Supplies — Site JavaScript
   ================================================ */

document.addEventListener('DOMContentLoaded', function () {
  // --- Mobile Navigation ---
  var navToggle = document.querySelector('.nav-toggle');
  var mobileMenu = document.querySelector('.mobile-menu');
  var mobileClose = document.querySelector('.mobile-close');
  var mobileOverlay = document.querySelector('.mobile-overlay');
  var mobileLinks = document.querySelectorAll('.mobile-nav-links a');

  function openMenu() {
    mobileMenu.removeAttribute('inert');
    mobileMenu.classList.add('active');
    mobileMenu.setAttribute('aria-hidden', 'false');
    navToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileMenu.classList.remove('active');
    mobileMenu.setAttribute('aria-hidden', 'true');
    mobileMenu.setAttribute('inert', '');
    navToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (navToggle) {
    navToggle.addEventListener('click', openMenu);
  }
  if (mobileClose) {
    mobileClose.addEventListener('click', closeMenu);
  }
  if (mobileOverlay) {
    mobileOverlay.addEventListener('click', closeMenu);
  }
  mobileLinks.forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });

  // --- Escape Key Dismiss ---
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('active')) {
      closeMenu();
    }
  });

  // --- FAQ Accordion ---
  var faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function (item) {
    var button = item.querySelector('.faq-question');
    if (button) {
      button.addEventListener('click', function () {
        var isOpen = item.classList.contains('active');
        // Close all others
        faqItems.forEach(function (other) {
          other.classList.remove('active');
          var otherBtn = other.querySelector('.faq-question');
          if (otherBtn) {
            otherBtn.setAttribute('aria-expanded', 'false');
          }
        });
        // Toggle current
        if (!isOpen) {
          item.classList.add('active');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    }
  });

  // --- Dynamic Copyright Year ---
  var yearEls = document.querySelectorAll('.copyright-year');
  yearEls.forEach(function (el) {
    el.textContent = new Date().getFullYear();
  });

  // --- Nav Scroll Effect ---
  var nav = document.querySelector('.site-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    });
    // Check on load in case page is already scrolled
    nav.classList.toggle('scrolled', window.scrollY > 60);
  }

  // --- Product Image Gallery ---
  var thumbs = document.querySelectorAll('.gallery-thumb');
  var mainImage = document.getElementById('main-image');
  // Zoom should work even with a single image (no thumbnails). The thumb
  // click loop below is a no-op when there are none; the overlay builder
  // already falls back to the main image and hides prev/next for 1 image.
  if (mainImage) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        var newSrc = thumb.getAttribute('data-src');
        mainImage.removeAttribute('srcset');
        mainImage.src = newSrc;
        mainImage.alt = thumb.querySelector('img').alt;
      });
    });
    mainImage.style.cursor = 'zoom-in';
    mainImage.addEventListener('click', function () {
      // Build gallery items list from the thumb row (preserves display order).
      var galleryItems = Array.from(thumbs).map(function (t) {
        var thumbImg = t.querySelector('img');
        return { src: t.getAttribute('data-src'), alt: thumbImg ? thumbImg.alt : '' };
      });
      if (!galleryItems.length) {
        galleryItems = [{ src: mainImage.src, alt: mainImage.alt }];
      }
      var currentIndex = galleryItems.findIndex(function (it) {
        return mainImage.src.indexOf(it.src.replace(/^(https?:)?\/\//, '')) !== -1 || it.src === mainImage.src;
      });
      if (currentIndex < 0) currentIndex = 0;

      function highRes(url) { return url.replace(/width=\d+/, 'width=2048'); }

      var overlay = document.createElement('div');
      overlay.className = 'gallery-zoom-overlay';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Product image viewer');

      var closeBtn = document.createElement('button');
      closeBtn.className = 'gallery-zoom-close';
      closeBtn.setAttribute('aria-label', 'Close zoom');
      closeBtn.textContent = '\u00D7';

      var prevBtn = document.createElement('button');
      prevBtn.className = 'gallery-zoom-nav gallery-zoom-prev';
      prevBtn.setAttribute('aria-label', 'Previous image');
      prevBtn.type = 'button';
      prevBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6 9 12l6 6" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      var nextBtn = document.createElement('button');
      nextBtn.className = 'gallery-zoom-nav gallery-zoom-next';
      nextBtn.setAttribute('aria-label', 'Next image');
      nextBtn.type = 'button';
      nextBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      var counter = document.createElement('div');
      counter.className = 'gallery-zoom-counter';

      var img = document.createElement('img');

      function render() {
        var item = galleryItems[currentIndex];
        img.src = highRes(item.src);
        img.alt = item.alt;
        counter.textContent = (currentIndex + 1) + ' / ' + galleryItems.length;
        var multi = galleryItems.length > 1;
        prevBtn.style.display = multi ? '' : 'none';
        nextBtn.style.display = multi ? '' : 'none';
        if (multi) {
          var n = (currentIndex + 1) % galleryItems.length;
          var p = (currentIndex - 1 + galleryItems.length) % galleryItems.length;
          [n, p].forEach(function (i) { (new Image()).src = highRes(galleryItems[i].src); });
        }
      }
      function step(dir) {
        currentIndex = (currentIndex + dir + galleryItems.length) % galleryItems.length;
        render();
      }
      function close() {
        document.removeEventListener('keydown', onKey);
        overlay.remove();
        document.body.style.overflow = '';
      }
      function onKey(e) {
        if (e.key === 'Escape') { e.preventDefault(); close(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      }

      prevBtn.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
      nextBtn.addEventListener('click', function (e) { e.stopPropagation(); step(1); });
      closeBtn.addEventListener('click', function (e) { e.stopPropagation(); close(); });
      img.addEventListener('click', function (e) { e.stopPropagation(); });
      overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
      document.addEventListener('keydown', onKey);

      // Touch swipe
      var touchStartX = 0, touchStartY = 0, touchActive = false;
      overlay.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchActive = true;
      }, { passive: true });
      overlay.addEventListener('touchend', function (e) {
        if (!touchActive) return;
        touchActive = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - touchStartX;
        var dy = t.clientY - touchStartY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          e.preventDefault();
          step(dx < 0 ? 1 : -1);
        }
      });

      overlay.appendChild(closeBtn);
      overlay.appendChild(prevBtn);
      overlay.appendChild(img);
      overlay.appendChild(nextBtn);
      overlay.appendChild(counter);
      document.body.style.overflow = 'hidden';
      document.body.appendChild(overlay);
      render();
      closeBtn.focus();
    });
  }

  // --- Contact Form (mockup) ---
  var contactForm = document.getElementById('contact-form');
  var successMsg = document.getElementById('contact-success');
  if (contactForm && successMsg) {
    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();
      contactForm.style.display = 'none';
      successMsg.classList.add('visible');
    });
  }

  // --- Express checkout: hide when a subscription selling plan is selected ---
  // Wallet buttons can start checkout without the Seal selling_plan value, so
  // a selected subscribe-and-save option must hide them. One-time (empty
  // selling_plan) keeps them visible. Sold-out PDPs never render the block.
  function sellingPlanIsSelected(root) {
    if (!root) return false;
    var inputs = root.querySelectorAll('[name="selling_plan"]');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      var type = (el.type || '').toLowerCase();
      if ((type === 'radio' || type === 'checkbox') && !el.checked) continue;
      var value = (el.value || '').trim();
      if (value && value !== '0') return true;
    }
    var active = root.querySelector('.sls-option-container.sls-active');
    if (active) {
      var planEl = active.querySelector('[name="selling_plan"], [data-selling-plan-id]');
      if (planEl) {
        var planId = (planEl.value || planEl.getAttribute('data-selling-plan-id') || '').trim();
        if (planId && planId !== '0') return true;
      }
    }
    return false;
  }

  function syncExpressVisibility(root) {
    var scope = root || document;
    var boxes = scope.querySelectorAll('[data-is-express]');
    boxes.forEach(function (box) {
      var form = box.closest('form');
      var hide = sellingPlanIsSelected(form || box.parentElement);
      box.hidden = hide;
      box.classList.toggle('is-express--hidden', hide);
      box.setAttribute('aria-hidden', hide ? 'true' : 'false');
    });
  }

  syncExpressVisibility(document);
  document.addEventListener('change', function (e) {
    if (!e.target) return;
    if (e.target.name === 'selling_plan' || (e.target.closest && e.target.closest('.sealsubs-container'))) {
      syncExpressVisibility(document);
    }
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.sealsubs-container')) {
      setTimeout(function () { syncExpressVisibility(document); }, 0);
    }
  });
  var expressForms = document.querySelectorAll('form[action*="/cart/add"], form[data-is-express-form]');
  expressForms.forEach(function (form) {
    if (typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function () { syncExpressVisibility(form); });
    observer.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'class'] });
  });

  // Narrow cart wallets sit side-by-side and ignore the 44px CSS variable.
  // Force the host, light-DOM children, and open shadow buttons/iframes.
  var WALLET_HEIGHT = '44px';
  function forceNodeHeight(node) {
    if (!node || !node.style) return;
    node.style.setProperty('box-sizing', 'border-box', 'important');
    node.style.setProperty('height', WALLET_HEIGHT, 'important');
    node.style.setProperty('min-height', WALLET_HEIGHT, 'important');
  }
  function walkWalletTree(node) {
    if (!node) return;
    var tag = (node.tagName || '').toLowerCase();
    if (tag === 'style' || tag === 'script' || tag === 'link') return;
    if (tag === 'iframe' || tag === 'button') {
      forceNodeHeight(node);
      node.style.setProperty('display', 'block', 'important');
      node.style.setProperty('flex', '1 1 0', 'important');
    } else if (node.style && tag) {
      node.style.setProperty('display', 'flex', 'important');
      node.style.setProperty('flex-flow', 'row nowrap', 'important');
      node.style.setProperty('align-items', 'stretch', 'important');
      forceNodeHeight(node);
    }
    var children = node.children || [];
    for (var i = 0; i < children.length; i++) walkWalletTree(children[i]);
    if (node.shadowRoot) walkWalletTree(node.shadowRoot);
  }
  function syncWalletButtonHeights(scope) {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    var hosts = (scope || document).querySelectorAll(
      '.is-express--cart shopify-accelerated-checkout-cart, .cart-checkout-dock shopify-accelerated-checkout-cart, dialog.cart-drawer__dialog shopify-accelerated-checkout-cart, .is-express--cart .additional-checkout-buttons'
    );
    hosts.forEach(function (host) {
      host.style.setProperty('--shopify-accelerated-checkout-button-block-size', WALLET_HEIGHT);
      host.style.setProperty('--shopify-accelerated-checkout-button-inline-size', '154px');
      forceNodeHeight(host);
      host.style.setProperty('display', 'flex', 'important');
      host.style.setProperty('flex-flow', 'row nowrap', 'important');
      host.style.setProperty('align-items', 'stretch', 'important');
      walkWalletTree(host);
    });
  }

  // Chat bubble lives in #is-chatbot-widget's open shadow root as
  // position:fixed (default bottom: 90px). Raise it above the mobile
  // /cart dock or a visible PDP sticky ATC — never hide it.
  var CHAT_GAP = 12;
  var CHAT_DEFAULT_BOTTOM = 90;
  function measureStickyChrome() {
    var lift = 0;
    var dock = document.querySelector('[data-cart-sticky]');
    if (dock && window.matchMedia('(max-width: 640px)').matches) {
      var dockStyle = window.getComputedStyle(dock);
      if (dockStyle.position === 'fixed' && dock.offsetHeight) {
        lift = Math.max(lift, dock.offsetHeight);
      }
    }
    var atc = document.querySelector('.sticky-atc.sticky-atc--visible');
    if (atc && atc.offsetHeight) {
      lift = Math.max(lift, atc.offsetHeight);
    }
    return lift;
  }
  function applyChatLift(lift) {
    var host = document.getElementById('is-chatbot-widget');
    if (!host || !host.shadowRoot) return;
    var style = host.shadowRoot.getElementById('is-theme-chat-lift');
    if (!style) {
      style = document.createElement('style');
      style.id = 'is-theme-chat-lift';
      host.shadowRoot.appendChild(style);
    }
    if (lift > 0) {
      var bottom = Math.max(lift + CHAT_GAP, CHAT_DEFAULT_BOTTOM);
      style.textContent = '@media (max-width: 768px){.is-chat-bubble{bottom:' + bottom + 'px !important}}';
    } else {
      style.textContent = '';
    }
  }
  function syncStickyChrome() {
    var lift = measureStickyChrome();
    var hasLift = lift > 0;
    document.documentElement.style.setProperty('--is-chat-lift', hasLift ? (lift + CHAT_GAP) + 'px' : '0px');
    document.body.classList.toggle('has-chat-lift', hasLift);
    document.body.classList.toggle('has-sticky-atc', !!document.querySelector('.sticky-atc.sticky-atc--visible'));
    applyChatLift(lift);
    syncWalletButtonHeights(document);
    watchStickyTargets();
  }
  window.ISTheme = window.ISTheme || {};
  window.ISTheme.syncStickyChrome = syncStickyChrome;
  window.ISTheme.syncWalletButtonHeights = syncWalletButtonHeights;

  var chromeSyncQueued = false;
  function queueStickyChrome() {
    if (chromeSyncQueued) return;
    chromeSyncQueued = true;
    requestAnimationFrame(function () {
      chromeSyncQueued = false;
      syncStickyChrome();
    });
  }
  window.ISTheme.queueStickyChrome = queueStickyChrome;

  var chromeResizeObserver = null;
  function watchStickyTargets() {
    if (typeof ResizeObserver === 'undefined') return;
    if (!chromeResizeObserver) chromeResizeObserver = new ResizeObserver(queueStickyChrome);
    document.querySelectorAll('[data-cart-sticky], .sticky-atc').forEach(function (el) {
      chromeResizeObserver.observe(el);
    });
  }

  syncStickyChrome();
  window.addEventListener('resize', queueStickyChrome);

  if (typeof MutationObserver !== 'undefined') {
    var chromeObserver = new MutationObserver(function (records) {
      for (var r = 0; r < records.length; r++) {
        var rec = records[r];
        if (rec.type === 'childList') {
          queueStickyChrome();
          return;
        }
        if (rec.target && rec.target.id === 'sticky-atc') {
          queueStickyChrome();
          return;
        }
      }
    });
    chromeObserver.observe(document.body, { childList: true, subtree: true });
    var stickyAtc = document.getElementById('sticky-atc');
    if (stickyAtc) {
      chromeObserver.observe(stickyAtc, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // --- Scroll Reveal ---
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('visible'); });
  }
});

